// =============================Icons===============================
import TelephoneIcon from "../assets/contactus/svg/telephone.svg";
import EmailIcon from "../assets/contactus/svg/mail.svg";
import LocationIcon from "../assets/contactus/svg/location.svg";

export const visGroupLocations = [
  {
    country: "GERMANY",
    companyName: "Vision PS GmbH",
    websiteHref: "https://www.vision-ps.de/",
    email: "info@visgroup.eu",
    address: "Vision PS GmbH Hansa Str 03 Duisburg, 47058, NRW",
  },
  {
    country: "UNITIED KINGDOM",
    companyName: "Perform Engineering Services LTD",
    websiteHref: "https://perform-es.com/",
    email: "info@visgroup.eu",
    address: "71-75, Shelton Street, Covent Garden, London",
  },
  {
    country: "ROMANIA",
    companyName: "Viscom ES SRL",
    websiteHref: "https://viscom-es.com/",
    email: "info@visgroup.eu",
    address:
      "No.16, Ap.2, Str. Grigore Moisil CLUJ Napoca CJ Rom 400499 - Romania",
  },

  {
    country: "UNITED ARAB EMIRATES",
    companyName: "Al Mafaheem Technologies",
    websiteHref: "https://mafaheem-tech.com/",
    email: "info@visgroup.eu",
    address: "Office No: 106, Behind Arouba Street, Al  Nabaa Sharjah  UAE ",
  },

  {
    country: "BAHRAIN",
    companyName: "BrainTime Technologies",
    websiteHref: "https://braintime-tech.com/",
    email: "info@visgroup.eu",
    address: "Office # 1817 Building # 470, Rd 1010 Block 410 (Sanabis) ",
  },

  {
    country: "SAUDI ARABIA",
    companyName: "Attractive Vision IT Services",
    websiteHref: "https://www.wikipedia.org/",
    email: "info@visgroup.eu",
    address: "Malaz, Salahdin Al-Ayoube Road, 11417 Riyadh",
  },
  // {
  //   country: "Pakistan",
  //   companyName: "Test Company NAME",
  //   websiteHref: "https://www.wikipedia.org/",
  //   email: "info@visgroup.eu",
  //   address: "Islamabad, Pakistan",
  // },

  // {
  //   country: "INDIA",
  //   companyName: "View26",
  //   websiteHref: "https://www.view26.com/",
  //   email: "info@visgroup.eu",
  //   address: "VIEW26 GmbH Hansastrasse 1-3, 47058 Duisburg, NRW",
  // },
];

export const contactUs = [
  { icon: TelephoneIcon, title: "Call us", desc: "+49-20334689340" },
  { icon: EmailIcon, title: "Email us at", desc: "info@vis-group.eu" },
  {
    icon: LocationIcon,
    title: "Our Address",
    desc: "Vis Group, Hansa Str 03, 47058, Duisburg, NRW, Germany",
  },
];
